import {
    FETCH_PRODUCT,
    USER_LOADING,
    USER_FAIL,
} from '../constants/types';

const initialState = {
    loading: false,
    data: [],
    error: ''
}

export function productData(state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCT:
            return {
                ...state,
                data: action.payload,
                loading: false
            }

        case USER_LOADING:
            return {
                ...state,
                data: [],
                loading: true,
            }

        case USER_FAIL:
            return {
                ...state,
                data: [],
                loading: false,
                error: action.payload
            }
        default:
            return state;
    }
}